// TODO: удалить при удалинии эксперимента паузы подписки
export const getPausedSubscriptionStorageKey = (subscriptionId) => `${subscriptionId}-paused`;

export const isPausedSubscription = (pauseSubscriptionFeature: string, renewAt: number = 0) =>
    pauseSubscriptionFeature && renewAt && renewAt > new Date().valueOf();
